import { useState, useContext } from 'react';

import { AppContext } from 'commons-ui';
import { ContentPropsT, IKindRewardCreditPayload } from '../kindReward.model';

const useFilter = (props: ContentPropsT) => {
	const { handleRewardCredit, onClose, rowData } = props;

	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);

	const handleFormSubmit = async (submittedData: IKindRewardCreditPayload): Promise<void> => {
		try {
			setShowLoader(true);
			handleRewardCredit(submittedData, rowData);
			setShowLoader(false);
		} catch (error) {
			showAlert('Error in crediting kind reward', { type: 'error' });
		} finally {
			onClose();
		}
	};

	const handleFormCancel = (): void => {
		onClose();
	};

	return {
		showLoader,
		setShowLoader,
		handleFormSubmit,
		handleFormCancel
	};
};

export default useFilter;
